module.exports = __webpack_public_path__ + "img/znch_desc.dcafe61.png";